import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type FormData} from './types';

const domain = 'OCCUPANCY_REPORT';

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {
    action: fetchReport,
    success: fetchReportSuccess,
    failed: fetchReportFailed,
} = createAction(
    `${domain}/FETCH_REPORT`,
    (institutionId: string, formData: FormData) => ({institutionId, formData}),
    (reportData: any) => ({reportData}),
);

export const {action: toggleAgeGroupDetails} = createAction(
    `${domain}/TOGGLE_AGE_GROUP_DETAILS`,
    (ageGroupId: string, show: boolean) => ({ageGroupId, show}),
);

export const {action: toggleGroupDetails} = createAction(
    `${domain}/TOGGLE_GROUP_DETAILS`,
    (groupId: string, show: boolean) => ({
        groupId,
        show,
    }),
);

export const {action: toggleOccupancyPercentages} = createAction(
    `${domain}/TOGGLE_OCCUPANCY_PERCENTAGES`,
    (show: boolean) => ({
        show,
    }),
);
